module.exports = __webpack_public_path__ + "img/rocket.8f113f74.svg";